export default {"src":"/_next/static/media/modern-square-meters.069ec260.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};